import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/apps3/investment-fund'
});

const init = () => httpClient.get('/api/init');
const search = (params) => httpClient.get('/api/search', { params });

export const useInvestmentFundApi = () => ({
	init,
	search
});
